import { NumCell, FieldBlock } from "./NumCell";

const FREQ_LABEL = { hourly: "Hourly", daily: "Daily", weekly: "Weekly", monthly: "Monthly", yearly: "Yearly" };
export { FREQ_LABEL };

const Suffix = ({ children }) => <span className="text-xs text-gray-500 whitespace-nowrap">{children}</span>;

const SimpleField = ({ label, description, value, onChange, suffix, testId, digits = 2, max }) => (
  <FieldBlock label={label} description={description} testId={`${testId}-block`}>
    <div className="flex items-center gap-2">
      <NumCell value={value} onChange={onChange} testId={testId} digits={digits} className="max-w-[130px]" min={0} max={max} />
      <Suffix>{suffix}</Suffix>
    </div>
  </FieldBlock>
);

export const SimpleInputs = ({ inputs, set }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="rate-calc-simple-inputs">
    <SimpleField
      label="Hours per Week"
      description="How many hours a week is your shop open? (e.g. 9am–5pm, 5 days = 40 hours) Billable hours are based on this, not on each person's hours."
      value={inputs.hours_per_week}
      onChange={(v) => set({ hours_per_week: v })}
      suffix="hrs / week"
      testId="rate-calc-hours-per-week"
      max={168}
    />
    <SimpleField
      label="Utilization %"
      description="What % of your operating hours goes toward paid job work — setup, printing, finishing, and packing all count. This excludes only non-job time: general cleaning, admin, waiting for work, and breaks."
      value={inputs.utilization_pct}
      onChange={(v) => set({ utilization_pct: v })}
      suffix="%"
      testId="rate-calc-utilization"
      max={100}
    />
    <SimpleField
      label="Weeks of Downtime per Year"
      description="Public holidays, staff leave, and slow periods where the shop isn't at full capacity."
      value={inputs.downtime_weeks}
      onChange={(v) => set({ downtime_weeks: v })}
      suffix="weeks / year"
      testId="rate-calc-downtime"
      max={52}
    />
    <SimpleField
      label="Margin %"
      description="What you'd like to add on top of break-even, to actually turn a profit."
      value={inputs.margin_pct}
      onChange={(v) => set({ margin_pct: v })}
      suffix="%"
      testId="rate-calc-margin"
      max={99}
    />
  </div>
);
